import React from 'react';
import emailjs from '@emailjs/browser';
import { getFirestore, collection, addDoc } from 'firebase/firestore/lite';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './application.scss';
import Form from 'react-bootstrap/Form';

const MAX_COUNT = 3;

interface ApplicationProps {
  date: string;
  name: string;
  pronouns: string;
  email: string;
  handle: string;
  selectedMc1: string[];
  selectedMc2: string[];
  frq1: string;
  frq2: string;
  frq1Response: string;
  frq2Response: string;
}

const frqQuestions =['What’s something you’d want to tell your younger self about creativity?', 
  'What is a creative goal you’d love to complete for yourself throughout this cohort experience?',
  'Where do you draw creative inspiration from?',
  'What does sustainable creativity look or feel like to you?',
  'What kind of support or collaboration are you craving right now?'
]

const mc1Options = ['Just starting out 🌱',
  'Slowly building ⚙️',
  'Full-time creative 🎨',
  'Side hustle status 🚀',
  'Mainly a hobby 💃'
  ];


const mc2Options = [' Creative accountability 👯',
  'Get out of my comfort zone 👻',
  'Supportive community 💛',
  'Business tips/resources 👔',
  'A reason to prioritize art 🖌️',
  'Collaboration opportunities 🤝',
  ];


const Application = () => {
  const init: ApplicationProps = {
    date: new Date().toLocaleString(),
    name: '',
    pronouns: '',
    email: '',
    handle: '',
    selectedMc1: [],
    selectedMc2: [],
    frq1: '',
    frq2: '',
    frq1Response: '',
    frq2Response: '',
  };
  const [form, setForm] = React.useState(init);
  const [acknowledged, setAcknowledged] = React.useState(false);
  const [selectedMc1, setSelectedMc1] = React.useState<string[]>([]);
  const [selectedMc2, setSelectedMc2] = React.useState<string[]>([]);
  const appsOpen = false;
  const db = getFirestore();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const updateMc1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.currentTarget.value;
    if (event.currentTarget.checked) {
      if (!selectedMc1.includes(val)){
        const newArray = [...selectedMc1, val];
        setSelectedMc1(newArray);
        setForm({
          ...form,
          ['selectedMc1']: newArray,
        });
      }
    } else {
      const newArray = selectedMc1.filter((item) => item !== val)
      setSelectedMc1(newArray);
      setForm({
        ...form,
        ['selectedMc1']: newArray,
      });
    }
  }

  const updateMc2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.currentTarget.value;
    if (!selectedMc2.includes(val)){
      const newArray = [...selectedMc2, val];
      setSelectedMc2(newArray);
      setForm({
        ...form,
        ['selectedMc2']: newArray,
      });
    } else {
    const newArray = selectedMc2.filter((item) => item !== val)
    setSelectedMc2(newArray);
    setForm({
      ...form,
      ['selectedMc2']: newArray,
    });
  }
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [event.currentTarget.id]: event.currentTarget.value,
    });
  };

async function handleSubmit(e: React.SyntheticEvent) {
  e.preventDefault();
  try {
    emailjs.init({
      publicKey: "01uX_BJIUEDfKbqR7",
    });
    emailjs.send('service_ygqthgk', 'template_t2odrec', {...form})
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
    alert('Request Sent!');
    setForm(init);
  } catch(error) {
    console.error('Error submitting request.');
  }
  }

  return (
    <div className='page cohort-form'>
      {
        appsOpen ? (
          <div>
          <div className='title'><span className='pink'>Ricecake</span> x <span className='orange'>Summertime Emmy</span> Creative Cohort </div>
            <div className='form'>
              <form id='bookingForm' onSubmit={handleSubmit}>
              <div className='formField'>
                  <span className='flexRow'>
                    <input
                      className='inputField name'
                      id='name'
                      type='text'
                      name='name'
                      value={form.name}
                      onChange={handleChange}
                      required
                      placeholder='Name*'
                    />
                    <input
                      className='inputField pronouns'
                      id='pronouns'
                      type='text'
                      name='pronouns'
                      value={form.pronouns}
                      onChange={handleChange}
                      placeholder='Pronouns'
                    />
                  </span>
                </div>
                <div className='formField'>
                  <span className='flexRow'>
                    <input
                        className='inputField email'
                        id='email'
                        type='email'
                        name='email'
                        value={form.email}
                        onChange={handleChange}
                        required
                        placeholder='Email*'
                      />
                      <input
                        className='inputField handle'
                        id='handle'
                        type='text'
                        name='handle'
                        value={form.handle}
                        onChange={handleChange}
                        required
                        placeholder='Instagram'
                      />
                    </span>
                </div>
                <div className="mc-1">
                  <div className='question'>Which of these describe your creative practice right now? <span className='italic'>(Check all that apply)</span></div>
                  <div className='options'>
                      {mc1Options.map((option, index) => (
                      <div className="checkbox-option">
                        <input // prettier-ignore
                          type='checkbox'
                          className='checkbox-option'
                          id={`mc1-${index}`}
                          value={option}
                          onChange={updateMc1}
                        />
                        <label htmlFor={`mc1-${index}`}>{option}</label>
                      </div>
                      ))}
                  </div>
                </div>
                <div className="mc-2">
                  <div className='question'>What are you most excited to gain from this cohort?</div>
                  <div className='options'>
                      {mc2Options.map((option, index) => (
                      <div className="checkbox-option">
                        <input // prettier-ignore
                          type='checkbox'
                          className='checkbox-option'
                          id={`mc2-${index}`}
                          value={option}
                          onChange={updateMc2}
                        />
                        <label htmlFor={`mc2-${index}`}>{option}</label>
                      </div>
                      ))}
                  </div>
                </div>
                <hr/>
                <div className='free-response'>
                  <div className='question'>💬 <span className='bold'>Short Answer Questions </span>(please answer the two that resonate with you most)</div>
                  <ol>
                    <li>What’s something you’d want to tell your younger self about creativity?
                    <div className='italic'>(This one’s always a tearjerker in the best way.)</div></li>
                    <li>What is a creative goal you’d love to complete for yourself throughout this cohort experience?
                    <div className='italic'>(Big or small, we love a dream in progress.)</div></li>
                    <li>Where do you draw creative inspiration from?
                    <div className='italic'>(Places, people, memories, aesthetics—whatever lights your spark.)</div></li>
                    <li>What does sustainable creativity look or feel like to you?
                    <div className='italic'>(We’re not here for burnout; we’re here for a softer, slower kind of success.)</div></li>
                    <li>What kind of support or collaboration are you craving right now?
                    <div className='italic'>(There are no wrong answers here—honesty helps us shape the vibe.)</div></li>
                    
                  </ol>
                  <div className='frq'>
                    Response 1
                    <select className='frq-question-select' id="type" name="question1" required
                      onChange={(event) => {
                        const question = parseInt(event.target.value);
                        setForm({...form, 'frq1': frqQuestions[question]});
                      }}>
                      <option value="" selected disabled hidden>Select Question Number</option>
                      <option value="0">1</option>
                      <option value="1">2</option>
                      <option value="2">3</option>
                      <option value="3">4</option>
                      <option value="4">5</option>
                    </select>
                    <div className='textarea'>
                      <textarea
                        className='frq1Response'
                        id='frq1Response'
                        value={form.frq1Response}
                        rows={4}
                        placeholder='Please type your response here! (600 char max)'
                        onInput={(event) => {
                          setForm({...form, 'frq1Response': event.currentTarget.value});}}
                        required
                      />
                    </div>
                  </div>
                  <div className='frq'>
                    Response 2
                    <select className='frq-question-select' id="type" name="question2" required
                      onChange={(event) => {
                        const question = parseInt(event.target.value);
                        setForm({...form, 'frq2': frqQuestions[question]});
                      }}>
                      <option value="" selected disabled hidden>Select Question Number</option>
                      <option value="0">1</option>
                      <option value="1">2</option>
                      <option value="2">3</option>
                      <option value="3">4</option>
                      <option value="4">5</option>
                    </select>
                    <div className='textarea'>
                      <textarea
                          className='frq2Response'
                          id='frq2Response'
                          value={form.frq2Response}
                          rows={4}
                          placeholder='Please type your response here! (600 char max)'
                          onInput={(event) => {
                            setForm({...form, 'frq2Response': event.currentTarget.value});}}
                          required
                        />
                      </div>
                  </div>
                </div>
                <div className="acknowledgement">
                <input type="checkbox" onChange={(e)=>{ setAcknowledged(e.target.checked)}}/>
                <label htmlFor="acknowledgement" className="acknowledgementText"> I confirm that I have read the <a href='/agreement'>Creative Cohort Participation Agreement</a> and am willing to commit to the requirements.
                </label>
                </div>
                <button id='submitButton'className='submit' type='submit' disabled={!acknowledged}>Submit</button>
              </form>
            </div> 
            </div>
        ) : (
          <div className="title">Applications for Fall 2025 are closed.</div>
        )
      }
    </div>
  );
}

export default Application;
